export default __webpack_public_path__ + "static/media/z_wdt_c_1.04d584fb.mp3";